import { useState } from 'react';
import { MatchingPropertieShow } from '../../exo/matching-properties/MatchingPropertieShow';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../special/updateOrCreate';

export const TypeSalesObjectPropertiesCustomer = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  const { t } = useTranslation();
  const { required, key } = field;
  const [open, setOpen] = useState(false);

  function handleChangedSelection(selection) {
    updateValidationOnChange([key], selection);
    setOpen(false);
  }

  function handlePropChange(data) {
    const newProps = updateOrCreate(dataCollection[key], data.data);
    handleChangedSelection(newProps);
  }

  const properties = dataCollection[key];

  return (
    <Box className="flex flex-col gap-4">
      {properties?.map((property) => (
        <MatchingPropertieShow
          key={property.id}
          property={property}
          isEditMode
          onChange={handlePropChange}
          isLead
          required={required}
          size="normal"
        />
      ))}
    </Box>
  );
};
